import { APP_ROUTE_VIEWS, type AppRouteView, inventoryRoutes } from '@/app/shell/routes';

export type AppView = AppRouteView;

interface NavigationItem {
  id: AppView;
  label: string;
  path: string;
}

export const navigationItems: NavigationItem[] = [
  {
    id: APP_ROUTE_VIEWS.today,
    label: 'Today',
    path: inventoryRoutes.root,
  },
  {
    id: APP_ROUTE_VIEWS.scan,
    label: 'Pasport',
    path: inventoryRoutes.scan,
  },
  {
    id: APP_ROUTE_VIEWS.sync,
    label: 'Sync',
    path: inventoryRoutes.sync,
  },
  {
    id: APP_ROUTE_VIEWS.meters,
    label: 'Meters',
    path: inventoryRoutes.meters,
  },
];
